import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-footer',
  templateUrl: './page-footer.component.html',
  styleUrls: ['./page-footer.component.scss'],
})
export class PageFooterComponent {
  @Input() copyrightText: string = 'RH Gestão';
  @Input() instagramUrl: string | null = null;
  @Input() facebookUrl: string | null = null;
  @Input() xUrl: string | null = null;
  @Input() linkedinUrl: string | null = null;
  @Input() backgroundColor: string = '#005DF5';
  @Input() textColor: string = 'white';

  get currentYear(): number {
    return new Date().getFullYear();
  }
}
